import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { Terminal } from "../components/SceneChrome";
import { NAME, ROLE, TAGLINE } from "../data/resume";

// Scene 0 — Boot (0–5%): the terminal types elbert.init(), then the text
// gives way to the name + role. Echoes the existing molecules/codeIntro.
const Scene0Boot: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const nameEnter = spring({
    frame: frame - 26,
    fps,
    config: { damping: 15, stiffness: 110 },
  });

  return (
    <AbsoluteFill
      style={{
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#181818",
      }}
    >
      <div
        style={{
          opacity: interpolate(frame, [22, 30], [1, 0], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          }),
          scale: String(
            interpolate(frame, [22, 32], [1, 0.9], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            })
          ),
        }}
      >
        <Terminal
          lines={[
            { text: "elbert.init()", from: 2, charsPerFrame: 1.4 },
            {
              text: "loading 8 years of experience... ok",
              from: 14,
              charsPerFrame: 3,
              color: "#8f8f8f",
            },
          ]}
        />
      </div>
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          opacity: interpolate(nameEnter, [0, 0.5], [0, 1], {
            extrapolateRight: "clamp",
          }),
          scale: String(0.8 + nameEnter * 0.2),
        }}
      >
        <div
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 600,
            fontSize: 130,
            color: "white",
            letterSpacing: 10,
          }}
        >
          {NAME}
        </div>
        <div
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 36,
            color: "#fcaeea",
            marginTop: 12,
          }}
        >
          {ROLE}
        </div>
        <div
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: 28,
            color: "#b3b3b3",
            marginTop: 10,
          }}
        >
          {TAGLINE}
        </div>
        <div
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 24,
            color: "#666",
            marginTop: 60,
            opacity: Math.floor(frame / 10) % 2 === 0 ? 1 : 0.3,
          }}
        >
          scroll to begin ↓
        </div>
      </div>
    </AbsoluteFill>
  );
};

export default Scene0Boot;
